import { PricingPlan } from "@/hooks/useSubscription";
import { PricingFeature } from "./PricingFeaturesList";
import PricingFeaturesList from "./PricingFeaturesList";
import SubscribeButton from "./SubscribeButton";
interface PricingCardsProps {
  plans: PricingPlan[];
  featuresList: PricingFeature[];
  formatPrice: (priceCents: number) => string;
  user: any;
  isCurrentPlan: (planId: string) => boolean;
  handleSubscribe: (planId: string) => void;
  loading: boolean;
}
export default function PricingCards({
  plans,
  featuresList,
  formatPrice,
  user,
  isCurrentPlan,
  handleSubscribe,
  loading
}: PricingCardsProps) {
  // Helper function to override price for monthly
  const customFormatPrice = (plan: PricingPlan) => {
    if (plan.type === "monthly") {
      return "$5.99";
    }
    return formatPrice(plan.price_cents);
  };

  // Clean descriptions to remove any token references
  const cleanDescription = (plan: PricingPlan) => {
    if (!plan.description) return "";
    // Remove any references to tokens or token limits
    return plan.description.replace(/\s*with\s*\d+k?\s*tokens\/month/i, "");
  };
  return <div className="grid md:grid-cols-3 gap-6 mt-4">
      {plans.map(plan => {
      const isPopular = plan.type === "yearly";
      return <div key={plan.id} className={`rounded-xl overflow-hidden border ${isPopular ? "border-primary shadow-lg shadow-primary/10" : "border-border"}`}>
            {isPopular && <div className="bg-primary text-primary-foreground text-center py-1.5 text-sm font-medium">
                Most Popular
              </div>}
            
            <div className="p-6">
              <h3 className="text-lg font-semibold mb-1">{plan.name}</h3>
              <p className="text-sm text-muted-foreground mb-4">{cleanDescription(plan)}</p>
              
              <div className="mb-4">
                <span className="text-3xl font-bold">{customFormatPrice(plan)}</span>
                {plan.type !== "free" && <span className="text-muted-foreground">
                    /{plan.type === "monthly" ? "month" : "year"}
                  </span>}
                {plan.type === "yearly" && <div className="mt-1 text-xs text-primary font-medium">Save 30% compared to monthly</div>}
              </div>
              
              <PricingFeaturesList features={featuresList} planType={plan.type} />
              
              <SubscribeButton plan={plan} user={user} isCurrentPlan={isCurrentPlan} handleSubscribe={handleSubscribe} loading={loading} className="w-full" />
            </div>
          </div>;
    })}
    </div>;
}